import EventsAdapter from './base';

export default class Risk extends EventsAdapter {
  modelNamePlural = 'risks';
}
